/**
 * @author        denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright     Copyright (c) 2022, Zumper
 */

import type { RawSchool, RawSchools, School, Schools } from '@zcode/state-type'
import { Bizo, autoclass } from '../../../shared/bizos/base'

const SCHOOL_TYPE_DEFINITION = {
  name: 'name',
  address: 'address',
  city: 'city',
  state: 'state',
  zipcode: 'zipcode',
  gradeAcademics: 'grade_academics',
  gradeOverall: 'grade_overall',
  gradesOffered: 'grades_offered',
  isPublic: 'is_public',
  isMagnet: 'is_magnet',
  isCharter: 'is_charter',
  phoneNumber: 'phone_number',
  website: 'website',
  totalStudents: 'total_students',
  distance: 'distance',
  driveTime: 'drive_time',
  proximity: (t: School) => ({
    distance: t.distance,
    driveTime: t.driveTime,
  }),
  lat: 'latitude',
  lng: 'longitude',
} as const

const SchoolType = autoclass<School, RawSchool>(
  'SchoolType',
  class SchoolType extends Bizo<School, RawSchool> {},
  SCHOOL_TYPE_DEFINITION,
  null
)

const DEFINITION = {
  schools: { name: 'schools', type: SchoolType, isArray: true },
} as const

export const LocationSchool = autoclass<Schools, RawSchools>(
  'DistrictSchool',
  class DistrictSchool extends Bizo<Schools, RawSchools> {},
  DEFINITION,
  null
)

export const LocationSchools = {
  fromJS: (data: RawSchool[]) => {
    if (data) {
      if (Array.isArray(data)) {
        return data.map((school) => SchoolType.fromJS(school))
      }
    }
    return []
  },
}
